import React from 'react'
import { Element } from 'react-bulma-components'

interface WorkerCountersExplanationProps {
  textColor?: string
}

/**
 * Composant d'explication pour les compteurs de travailleurs
 * Explique le concept et l'utilisation des compteurs dans l'application
 */
const WorkerCountersExplanation: React.FC<WorkerCountersExplanationProps> = ({ textColor }) => {
  return (
    <>
      <Element mb={2}>
        Les compteurs permettent de suivre et d'agréger automatiquement les durées liées aux
        activités des employés. <br />
        Ils sont basés sur les règles employeur et s'appliquent uniquement aux salariés internes.
        <br />
        Ils agrègent les durées lors de la validation d'une semaine d'un salarié dans la vue Paie.
      </Element>

      <Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Modification manuelle
        </Element>
        <Element>
          Les membres de l'employeur peuvent ajuster manuellement les valeurs des compteurs.
        </Element>
      </Element>

      <Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Exemple : Suivi des heures supplémentaires
        </Element>
        <Element>
          Comptabiliser automatiquement les heures supplémentaires effectuées par un employé par
          semaine, en se basant sur les règles employeur de calcul définies.
          <br />
          La modification manuelle peut être utilisée pour déduire les récupérations RTT.
        </Element>
      </Element>

      <Element>
        <Element renderAs="i" textSize={7}>
          Pour toute modification ou ajout de compteurs, veuillez contacter votre administrateur
          TeamTim.
        </Element>
      </Element>
    </>
  )
}

export default WorkerCountersExplanation
